<app-tab>
  <dx-data-grid
    id="trailerOperationTypesGridContainer"
    [dataSource]="ds"
    [libGridDefault]="{stateStorageKey: 'app-trailer-operation-grid'}"
    [remoteOperations]="false"
    [libGridTitle]="{text: 'Opérations Agricoles'}">

    <dxi-column
      caption="ID"
      dataField="id"
      sortOrder="desc"
      width="5%"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataType="number">
    </dxi-column>

    <dxi-column
      caption="Nom"
      dataField="name">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule type="stringLength" [min]="3" [max]="100"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Nombre d'outils"
      width="10%"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataField="total_trailers">
    </dxi-column>


    <dxi-column
      caption="Date création"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataField="created_at"
      format="shortDateShortTime"
      dataType="date">
    </dxi-column>

    <dxi-column
      caption="Date modification"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataField="updated_at"
      format="shortDateShortTime"
      dataType="date">
    </dxi-column>

    <dxi-column
      caption="Vitesse Minimale"
      dataType="number"
      dataField="rules.min_speed"
      [visible]="false"
      [showInColumnChooser]="false">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Vitesse Maximale"
      dataType="number"
      dataField="rules.max_speed"
      [visible]="false"
      [showInColumnChooser]="false">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>


    <dxo-editing
      mode="popup"
      [allowDeleting]="canDelete"
      [allowAdding]="canAdd"
      [allowUpdating]="canEdit">

      <dxo-popup width="40%" [height]="300"></dxo-popup>

      <dxo-form labelLocation="top">
        <dxi-item dataField="name" [colSpan]="2"></dxi-item>

        <dxi-item itemType="group" colSpan="2" colCount="2" caption="Règles">
          <dxi-item dataField="rules.min_speed"></dxi-item>
          <dxi-item dataField="rules.max_speed"></dxi-item>
        </dxi-item>

      </dxo-form>
    </dxo-editing>

    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

    <dxo-group-panel [visible]="false"></dxo-group-panel>

    <dxo-export [enabled]="true" [fileName]="'liste-types-operations'"
                [allowExportSelectedData]="true"></dxo-export>

    <dxo-sorting mode="multiple"></dxo-sorting>

    <dxo-paging [pageSize]="25"></dxo-paging>

    <dxo-pager
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[25, 50, 100]"
      [showInfo]="true">
    </dxo-pager>

    <dxo-filter-row [visible]="true"></dxo-filter-row>

    <dxo-search-panel
      [visible]="true"
      [width]="240"></dxo-search-panel>

    <dxo-header-filter [visible]="true"></dxo-header-filter>

  </dx-data-grid>
</app-tab>
